import { AutoCompleteDesignTokens } from '@primeuix/themes/types/autocomplete';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/autocomplete/index.ts
const ac = componentCommon.autocomplete;
const acCs = componentColorScheme.autocomplete;

export const AutoCompleteTelekomDT: AutoCompleteDesignTokens = {
  root: {
    background: t(ac.background),
    color: t(ac.color),
    disabledBackground: t(ac.disabled.background),
    disabledColor: t(ac.disabled.color),
    filledBackground: t(ac.filled.background),
    filledHoverBackground: t(ac.filled.hover.background),
    filledFocusBackground: t(ac.filled.focus.background),
    borderColor: t(ac.border.color),
    borderRadius: t(ac.border.radius),
    hoverBorderColor: t(ac.hover.border.color),
    focusBorderColor: t(ac.focus.border.color),
    invalidBorderColor: t(ac.invalid.border.color),
    placeholderColor: t(ac.placeholder.color),
    invalidPlaceholderColor: t(ac.invalid.placeholder.color),
    paddingX: t(ac.padding.x),
    paddingY: t(ac.padding.y),
    focusRing: {
      width: t(ac.focus.ring.width),
      color: t(ac.focus.ring.color),
      offset: t(ac.focus.ring.offset),
    },
  },
  overlay: {
    background: t(ac.overlay.background),
    borderColor: t(ac.overlay.border.color),
    borderRadius: t(ac.overlay.border.radius),
    color: t(ac.overlay.color),
  },
  list: {
    gap: t(ac.list.gap),
    padding: t(ac.list.padding.y),
  },
  option: {
    color: t(ac.option.color),
    focusBackground: t(ac.option.focus.background),
    focusColor: t(ac.option.focus.color),
    selectedBackground: t(ac.option.selected.background),
    selectedColor: t(ac.option.selected.color),
    selectedFocusBackground: t(ac.option.selected.focus.background),
    selectedFocusColor: t(ac.option.selected.focus.color),
    borderRadius: t(ac.option.border.radius),
    padding: t(ac.option.padding.y),
  },
  optionGroup: {
    background: t(ac.option.group.background),
    color: t(ac.option.group.color),
    padding: t(ac.option.group.padding.y),
  },
  dropdown: {
    width: t(ac.dropdown.width),
    sm: { width: t(ac.dropdown.sm.width) },
    lg: { width: t(ac.dropdown.lg.width) },
    borderColor: t(ac.dropdown.border.color),
    borderRadius: t(ac.dropdown.border.radius),
    hoverBorderColor: t(ac.dropdown.hover.border.color),
    activeBorderColor: t(ac.dropdown.active.border.color),
    focusRing: {
      width: t(ac.dropdown.focus.ring.width),
      color: t(ac.dropdown.focus.ring.color),
      offset: t(ac.dropdown.focus.ring.offset),
    },
    background: t(acCs.dropdown.background),
    hoverBackground: t(acCs.dropdown.hover.background),
    activeBackground: t(acCs.dropdown.active.background),
    color: t(acCs.dropdown.color),
    hoverColor: t(acCs.dropdown.hover.color),
    activeColor: t(acCs.dropdown.active.color),
  },
  chip: {
    borderRadius: t(ac.chip.border.radius),
    focusBackground: t(acCs.chip.focus.background),
    focusColor: t(acCs.chip.focus.color),
  },
};
